import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type OrderStatus =
  | "neu"
  | "bezahlt"
  | "versendet"
  | "storniert"
  | "geparkt"
  | "erledigt"
  | "unerledigt";
export type InvoiceStatus = "offen" | "bezahlt" | "storniert";
export type ShippingStatus = "ausstehend" | "versendet" | "zugestellt" | "retoure";
export type StatusValue = OrderStatus | InvoiceStatus | ShippingStatus | string;

export interface StatusBadgeProps {
  status: StatusValue;
  className?: string;
}

function getStatusClasses(status: StatusValue): string {
  switch (status) {
    case "bezahlt":
    case "erledigt":
    case "zugestellt":
      return "bg-success-soft text-success border-transparent";
    case "neu":
    case "offen":
    case "ausstehend":
      return "bg-primary-soft text-primary border-transparent";
    case "versendet":
      return "bg-primary-soft text-primary border-transparent";
    case "storniert":
      return "bg-coral-soft text-coral border-transparent";
    case "geparkt":
    case "retoure":
    case "unerledigt":
      return "bg-warn-soft text-warn border-transparent";
    default:
      return "bg-panel-2 text-ink-2 border-transparent";
  }
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge variant="outline" className={cn(getStatusClasses(status), className)}>
      {status}
    </Badge>
  );
}
